import { loadAsset } from '../utils/AddressableManager';
import * as THREE from 'three';

const prefabRegistry = {
  Saturn: {
    type: 'gltf',
    parts: [
      { key: 'SaturnRingInner', url: '/models/rings/saturn/ring_inner.glb', scale: 1 },
      { key: 'SaturnRingMain', url: '/models/rings/saturn/ring_main.glb', scale: 1 },
      { key: 'SaturnRingOuter', url: '/models/rings/saturn/ring_outer.glb', scale: 1 },
    ],
    rotation: [Math.PI / 2, 0, 0],
  },
  Uranus: {
    type: 'gltf',
    parts: [
      { key: 'UranusRingInner', url: '/models/rings/uranus/ring_inner.glb', scale: 1 },
      { key: 'UranusRingMain', url: '/models/rings/uranus/main_division.glb', scale: 1 },
      { key: 'UranusRingOuter', url: '/models/rings/uranus/outer_diffuse.glb', scale: 1 },
    ],
    rotation: [Math.PI / 2, 0, 0],
  },
   Jupiter: {
    type: 'gltf',
    parts: [
      { key: 'JupiterRingInner', url: '/models/rings/jupiter/ring_inner.glb', scale: 1 },
      { key: 'JupiterRingMain', url: '/models/rings/jupiter/ring_main.glb', scale: 1 },
      { key: 'JupiterRingOuter', url: '/models/rings/jupiter/ring_outer.glb', scale: 1 },
    ],
    rotation: [Math.PI / 2, 0, 0],
  },
   Neptune: {
    type: 'gltf',
    parts: [
      { key: 'NeptuneRingInner', url: '/models/rings/neptune/ring_inner.glb', scale: 1 },
      { key: 'NeptuneRingMain', url: '/models/rings/neptune/ring_main.glb', scale: 1 },
      { key: 'NeptuneRingOuter', url: '/models/rings/neptune/ring_outer.glb', scale: 1 },
    ],
    rotation: [Math.PI / 2, 0, 0],
  },
};

export async function getRingPrefab(planetName) {
  const prefab = prefabRegistry[planetName];
  if (!prefab) return null;

  const group = new THREE.Group();

  for (const { key, url, scale = 1 } of prefab.parts) {
    const gltf = await loadAsset('gltf', key, url);
    const obj = gltf.scene.clone(true);

    // Traverse children and reset rotation
    obj.traverse((child) => {
      if (child.isMesh) {
        child.rotation.x = Math.PI /2;
        child.updateMatrix();
      }
    });

    obj.rotation.set(0, 0, 0); // Ensure base object has no tilt
    obj.scale.setScalar(scale);
    obj.updateMatrixWorld();

    group.add(obj);
  }

  // Apply horizontal ring alignment — this rotates the entire ring system
  if (prefab.rotation) {
    group.rotation.set(...prefab.rotation); // Usually [Math.PI / 2, 0, 0]
  }

  return group;
}
